import styled from 'styled-components';

export const Button = styled.button`
    background-image: url(${props => props.background}) !important;
`